import constants from "constants/constants";
import { FILE_SIZES } from "features/Common/modules/File/File.constants";
import {
  ACCEPTED_FILE_TYPES,
  HEADER_MEDIA_OPTIONS,
} from "ui/pages/whatsappBroadcast/whatsappBroadcast.constants";
import { useNotifications } from "utils/hooks";
import { is_empty } from "utils/validations";

export const useUpload = () => {
  const { notify } = useNotifications();

  const getVideoObject = (e) => {
    //Checking if file size is under 16MB. Returning Error otherwise
    if (
      e.target.files.length &&
      e.target.files[0].size < FILE_SIZES.MAX_VIDEO_SIZE.value
    ) {
      let file = e.target.files[0];

      const isFileSupported = file.type === ACCEPTED_FILE_TYPES.MP4;
      if (!isFileSupported) {
        return notify("File type not supported. Try another file", "error");
      }

      return {
        preview: URL.createObjectURL(e.target.files[0]),
        raw: file,
        type: HEADER_MEDIA_OPTIONS.VID,
        name: file?.name,
      };
    } else {
      notify(
        `Error: File size is greater than ${FILE_SIZES.MAX_VIDEO_SIZE.label}`,
        "error"
      );
    }
  };

  const getDocObject = (e) => {
    //Checking if file size is under 100MB. Returning Error otherwise
    if (
      e.target.files.length &&
      e.target.files[0].size < FILE_SIZES.MAX_DOC_SIZE.value
    ) {
      let file = e.target.files[0];

      const isFileSupported = file.type === ACCEPTED_FILE_TYPES.PDF;
      if (!isFileSupported) {
        return notify("File type not supported. Try another file", "error");
      }

      return {
        preview: URL.createObjectURL(e.target.files[0]),
        raw: file,
        type: HEADER_MEDIA_OPTIONS.DOC,
        name: file?.name,
      };
    } else {
      notify(
        `Error: File size is greater than ${FILE_SIZES.MAX_DOC_SIZE.label}`,
        "error"
      );
    }
  };

  const getPublicFileS3Url = ({
    key,
    bucket,
    region = constants.AWS_CRED.region,
  }) => {
    if (is_empty(key)) return;
    return `https://${bucket}.s3.${region}.amazonaws.com/${key}`;
  };

  /**
   * converts private S3 url of the CDN bucket to a publicly accessible url
   * @param {*} key path of the uploaded file
   * @param {*} bucket bucket in which the file is uploaded
   * @param {*} region s3 region.
   * @returns {*} Public url of updated file
   */
  const getPublicCdnUrl = ({
    key,
    bucket,
    region = constants.AWS_CRED.region,
  }) =>
    getPublicFileS3Url({ key, bucket, region }).replace(
      `https://${process.env.REACT_APP_S3_BUCKET_EXLY_CONTENT}.s3.${region}.amazonaws.com`,
      process.env.REACT_APP_EXLY_CONTENT_CDN_URL
    );

  return {
    getVideoObject,
    getDocObject,
    getPublicFileS3Url,
    getPublicCdnUrl,
  };
};
